import './style.css';
import React, { Component } from 'react';
import { withSnackbar } from 'notistack';
import {
  withApi,
  withUser,
  withMessages,
} from '../../services/AthomApi';
import Page from '../Page';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';

import FormGroup from '@material-ui/core/FormGroup';
import FormLabel from '@material-ui/core/FormLabel';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';

import IconButton from '@material-ui/core/IconButton';
import IconCopy from '@material-ui/icons/FileCopy';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import AddBoxIcon from '@material-ui/icons/AddBox';

import { CopyToClipboard } from "react-copy-to-clipboard";

class PageAPIClients extends Component {

  constructor(props) {
    super(props);

    this.state = {
      clients: null,
      createClient: null,
      updateClient: null,
      deleteClient: null,
    };
  }

  componentDidMount() {
    this.refresh();
  }

  // Refresh Clients
  refresh = () => {
    this.props.api.api.getAuthenticatedUserClients()
      .then(clients => {
        // Filter out 'account.homeys.readonly' scope
        for (const client of clients) {
          client.scopes = client.scopes.filter(scope => {
            if (scope === 'account.homeys.readonly') return false;
            return true;
          })
        }

        this.setState({ clients });
      })
      .catch(err => {
        if (err.message.includes('The authenticated client has no access to this resource')) {
          this.props.handleError('No permission yet, please logout and login again.');
        } else {
          this.props.handleError(err);
        }
      });
  }

  // Create Client
  handleCreateClientDialogOpen = () => {
    this.setState({
      createClient: {
        name: '',
        redirectUri: [],
        scopes: [],
      },
    });
  }

  handleCreateClientDialogClose = () => {
    this.setState({ createClient: null });
  }

  handleCreateClient = () => {
    this.props.api.api.createAuthenticatedUserClient({
      name: this.state.createClient.name,
      redirectUri: this.state.createClient.redirectUri.map(uri => uri.trim()).filter(uri => !!uri),
      scopes: this.state.createClient.scopes,
    })
      .then(client => {
        this.props.handleSuccess(`Client ${client.name} created`);
        this.setState({ createClient: null });
        this.refresh();
      })
      .catch(this.props.handleError);
  }

  // Update Client
  handleUpdateClientDialogOpen = client => {
    this.setState({
      updateClient: JSON.parse(JSON.stringify(client)),
    });
  }

  handleUpdateClientDialogClose = () => {
    this.setState({ updateClient: null });
  }

  handleUpdateClient = () => {
    this.props.api.api.updateAuthenticatedUserClient({
      id: this.state.updateClient.id,
      name: this.state.updateClient.name,
      redirectUri: this.state.updateClient.redirectUri.map(uri => uri.trim()).filter(uri => !!uri),
      scopes: this.state.updateClient.scopes,
    }).then(client => {
      this.props.handleSuccess(`Client ${this.state.updateClient.name} updated`);
      this.setState({ updateClient: null });
      this.refresh();
    }).catch(this.props.handleError);

  }

  // Delete Client
  handleDeleteClientDialogOpen = client => {
    this.setState({ deleteClient: client });
  }

  handleDeleteClientDialogClose = () => {
    this.setState({ deleteClient: null });
  }

  handleDeleteClient = () => {
    this.props.api.api.deleteAuthenticatedUserClient({
      id: this.state.deleteClient.id,
    }).then(() => {
      this.props.handleSuccess(`Client ${this.state.deleteClient.name} deleted`);
      this.refresh();
      this.setState({ deleteClient: null });
    }).catch(this.props.handleError);
  }

  // Render
  render() {
    const {
      clients,
      createClient,
      updateClient,
      deleteClient,
    } = this.state;

    return (
      <Page
        title="Web API Clients"
        toolbar={Array.isArray(clients) && clients.length > 0 && (
          <Button
            onClick={this.handleCreateClientDialogOpen}
            variant="contained"
            color="primary"
          >
            <AddBoxIcon />&nbsp;
            New Client
          </Button>
        )}
      >
        <Typography variant="body1">Users can authenticate with an OAuth2 Web API Client and delegate access to their Homey Pro. <a href="https://api.developer.homey.app" target="_blank">Web API Documentation »</a></Typography>

        {clients === null && (
          <center style={{
            marginTop: 100,
          }}>
            <CircularProgress />
          </center>
        )}

        {Array.isArray(clients) && clients.length === 0 && (
          <center style={{
            marginTop: 100,
            marginBottom: 50,
          }}>
            <Typography variant="h6">{`Let's create your first Web API Client!`}</Typography>
            <br />
            <Button
              onClick={this.handleCreateClientDialogOpen}
              variant="contained"
              color="primary"
            >
              <AddBoxIcon />&nbsp;
              New Client
            </Button>
          </center>
        )}

        {Array.isArray(clients) && clients.length > 0 && (
          <div style={{
            overflowX: 'auto',
          }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Credentials</TableCell>
                  <TableCell>Scopes</TableCell>
                  <TableCell>Callback URLs</TableCell>
                  <TableCell>Users/Limit</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {clients.map(client => (
                  <TableRow>
                    <TableCell>{client.name}</TableCell>
                    <TableCell>
                      <div>
                        <strong>Client ID</strong><br />
                        <CopyToClipboard
                          title="Click to Copy to Clipboard"
                          style={{
                            cursor: 'pointer',
                          }}
                          text={client.id}
                          onCopy={() => {
                            this.props.handleSuccess('Copied to Clipboard');
                          }}
                        >
                          <pre>{client.id}</pre>
                        </CopyToClipboard>
                      </div>

                      <br />

                      <div>
                        <strong>Client Secret</strong><br />
                        <CopyToClipboard
                          title="Click to Copy to Clipboard"
                          style={{
                            cursor: 'pointer',
                          }}
                          text={client.secret}
                          onCopy={() => {
                            this.props.handleSuccess('Copied to Clipboard');
                          }}
                        >
                          <pre>{client.secret}</pre>
                        </CopyToClipboard>
                      </div>
                    </TableCell>
                    <TableCell><pre>{client.scopes.join('\n')}</pre></TableCell>
                    <TableCell><pre>{client.redirectUri.join('\n')}</pre></TableCell>
                    <TableCell>{client.usersCount} of {client.maxUsers ?? 'Infinite'}<br /><a href={`mailto:web-api@athom.com?subject=[${client.id}] Increase Web API Limits&body=Client ID: ${client.id}%0D%0AClient Name: ${client.name}%0D%0AScopes: ${client.scopes.join(', ')}%0D%0A%0D%0AI'd like to increase the maximum number of users for my Web API Client from ${client.maxUsers} to ..., because ...`}>Request Limit Increase &raquo;</a></TableCell>
                    <TableCell>
                      <IconButton onClick={() => this.handleUpdateClientDialogOpen(client)} title="Edit Client">
                        <EditIcon />
                      </IconButton>
                      <IconButton onClick={() => this.handleDeleteClientDialogOpen(client)} title="Delete Client">
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        )}

        <Dialog
          open={!!createClient}
        >
          {createClient && (
            <React.Fragment>
              <DialogTitle>New Web API Client</DialogTitle>
              <DialogContent>
                <FormLabel>Name</FormLabel>
                <FormGroup>
                  <TextField
                    value={createClient.name}
                    onChange={e => this.setState({
                      createClient: {
                        ...createClient,
                        name: e.target.value,
                      },
                    })}
                    placeholder='My Web API Client'
                    helperText={`This will show to the user as \`${createClient.name || 'API Client'} would like to: ...\``}
                    fullWidth
                  />
                </FormGroup>
                <br />

                <FormLabel>Callback URLs</FormLabel>
                <FormGroup>
                  <TextField
                    value={createClient.redirectUri.join('\n')}
                    onChange={e => {
                      this.setState({
                        createClient: {
                          ...createClient,
                          redirectUri: e.target.value.split('\n').map(uri => uri.trim()),
                        },
                      });
                    }}
                    fullWidth
                    multiline
                    placeholder={`https://example.com/callback\nhttps://example.dev/callback`}
                    helperText="One URL per line, with a maximum of 10."
                    inputProps={{
                      style: {
                        fontFamily: 'monospace',
                        fontSize: '0.8em',
                      }
                    }}
                  />
                </FormGroup>
                <br />

                <FormLabel>Scopes</FormLabel>
                <FormGroup>
                  <div style={{
                    columns: 2,
                  }}>
                    {[
                      'homey.zone.readonly',
                      'homey.device.readonly',
                      'homey.device.control',
                      'homey.flow.readonly',
                      'homey.flow.start',
                      'homey.user.readonly',
                      'homey.user.self',
                      'homey.presence.readonly',
                      'homey.presence.self',
                      'homey.notifications.readonly',
                      'homey.logic',
                      'homey.logic.readonly',
                      'homey.insights.readonly',
                      'homey.energy.readonly',
                      'homey.app.readonly',
                    ].map(scope => (
                      <>
                        <FormControlLabel
                          label={<code style={{
                            fontSize: '0.8em',
                          }}>{scope}</code>}
                          control={<Checkbox
                            size="small"
                            checked={createClient.scopes.includes(scope)}
                            onChange={(e, value) => {
                              if (value === true) {
                                createClient.scopes.push(scope);
                              } else {
                                createClient.scopes = createClient.scopes.filter(s => s !== scope);
                              }

                              this.setState({ createClient });
                            }}
                            color="primary"
                          />}
                        />
                      </>
                    ))}
                  </div>
                </FormGroup>
              </DialogContent>
              <DialogActions>
                <Button onClick={this.handleCreateClientDialogClose}>Cancel</Button>
                <Button
                  onClick={this.handleCreateClient}
                  color="primary"
                  disabled={!(createClient.name.trim() !== '' && createClient.redirectUri.length > 0 && createClient.scopes.length > 0)}
                >Create</Button>
              </DialogActions>
            </React.Fragment>
          )}
        </Dialog>

        <Dialog
          open={!!updateClient}
        >
          {updateClient && (
            <React.Fragment>
              <DialogTitle>Update Web API Client</DialogTitle>
              <DialogContent>
                <FormLabel>Name</FormLabel>
                <FormGroup>
                  <TextField
                    value={updateClient.name}
                    onChange={e => this.setState({
                      updateClient: {
                        ...updateClient,
                        name: e.target.value,
                      },
                    })}
                    placeholder='My Web API Client'
                    helperText={`This will show to the user as \`${updateClient.name || 'API Client'} would like to: ...\``}
                    fullWidth
                  />
                </FormGroup>
                <br />

                <FormLabel>Callback URLs</FormLabel>
                <FormGroup>
                  <TextField
                    value={updateClient.redirectUri.join('\n')}
                    onChange={e => {
                      this.setState({
                        updateClient: {
                          ...updateClient,
                          redirectUri: e.target.value.split('\n').map(uri => uri.trim()),
                        },
                      });
                    }}
                    fullWidth
                    multiline
                    placeholder={`https://example.com/callback\nhttps://example.dev/callback`}
                    helperText="One URL per line, with a maximum of 10."
                    inputProps={{
                      style: {
                        fontFamily: 'monospace',
                        fontSize: '0.8em',
                      }
                    }}
                  />
                </FormGroup>
                <br />

                <FormLabel>Scopes</FormLabel>
                <FormGroup>
                  <div style={{
                    columns: 2,
                  }}>
                    {[
                      'homey.zone.readonly',
                      'homey.device.readonly',
                      'homey.device.control',
                      'homey.flow.readonly',
                      'homey.flow.start',
                      'homey.user.readonly',
                      'homey.user.self',
                      'homey.presence.readonly',
                      'homey.presence.self',
                      'homey.notifications.readonly',
                      'homey.logic',
                      'homey.logic.readonly',
                      'homey.insights.readonly',
                      'homey.app.readonly',
                    ].map(scope => (
                      <>
                        <FormControlLabel
                          label={<code style={{
                            fontSize: '0.8em',
                          }}>{scope}</code>}
                          control={<Checkbox
                            size="small"
                            checked={updateClient.scopes.includes(scope)}
                            onChange={(e, value) => {
                              if (value === true) {
                                updateClient.scopes.push(scope);
                              } else {
                                updateClient.scopes = updateClient.scopes.filter(s => s !== scope);
                              }

                              this.setState({ updateClient });
                            }}
                            color="primary"
                          />}
                        />
                      </>
                    ))}
                  </div>
                </FormGroup>
              </DialogContent>
              <DialogActions>
                <Button onClick={this.handleUpdateClientDialogClose}>Cancel</Button>
                <Button
                  onClick={this.handleUpdateClient}
                  color="primary"
                  disabled={!(updateClient.name.trim() !== '' && updateClient.redirectUri.length > 0 && updateClient.scopes.length > 0)}
                >Update</Button>
              </DialogActions>
            </React.Fragment>
          )}
        </Dialog>

        <Dialog
          open={!!deleteClient}
        >
          {deleteClient && (
            <React.Fragment>
              <DialogTitle>Delete {deleteClient.name}</DialogTitle>
              <DialogContent>
                <Typography variant="body1">Any authenticated tokens will be revoked. Customers will not be able to use this Web API Client. Are you sure?</Typography>
              </DialogContent>
              <DialogActions>
                <Button onClick={this.handleDeleteClientDialogClose}>Cancel</Button>
                <Button onClick={() => {
                  const { deleteClient } = this.state;
                  this.handleDeleteClient(deleteClient);
                }} color="secondary">Delete</Button>
              </DialogActions>
            </React.Fragment>
          )}
        </Dialog>

      </Page>
    );
  }
}

export default withSnackbar(withMessages(withApi(withUser(PageAPIClients))));
